import Button from "@pathwright/ui/src/components/button/Button"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import { ScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import { OrderByDir } from "@pathwright/web/src/modules/api/generated"
import CohortMembers from "@pathwright/web/src/modules/cohort/CohortMembers"
import { getReviewRoute } from "@pathwright/web/src/modules/inbox/routes"
import { ConnectStores } from "lib/core/store"
import * as urls from "lib/core/utils/urls"
import PathViewAsControl from "library/show/components/path/controls/PathViewAsControl"
import { DESIGN, LEARN, TEACH } from "path/constants"
import React from "react"
import styled from "styled-components"
import "./PathActionControls.css"

const CohortMembersContainer = styled(Button)`
  border-radius: 20px;
  padding: 1px 10px !important;
  padding-right: 0px;
  background-color: rgba(153, 153, 153, 0.6);
  border: 0px;
  margin: 0px !important;
  height: auto !important;

  .CohortMembers {
    margin: 0px;
    padding: 0px;
    height: 30px !important;

    .Avatar {
      box-shadow: none;
    }
  }
`

const styles = {
  styleType: "primary-alt",
  rounded: false
}

class PathActionControls extends React.Component {
  renderReview = () => {
    // testing out path controls UX change
    // return null
    return (
      <Tooltip title={this.props.t("path.controls.review")}>
        <Button
          {...(styles || {})}
          to={this.props.toReview}
          icon="inbox"
          label={this.props.feedbackCount || ""}
          indicator={!!this.props.feedbackCount}
        />
      </Tooltip>
    )
  }

  renderPerformance = () => {
    return (
      <Button {...Object.assign({}, styles, { to: this.props.toPerformance })}>
        <Pathicon icon="gauge-square" />
        <span> {this.props.t("path.controls.performance")}</span>
      </Button>
    )
  }

  renderMembers = () => {
    // testing out path controls UX change
    // return null
    return (
      <CohortMembersContainer to={this.props.toMembers}>
        <CohortMembers
          size={24}
          itemOffset={-12}
          cohortId={this.props.offering.id}
          orderBy={{ last_activity_time: OrderByDir.Desc }}
          inverted
        />
      </CohortMembersContainer>
    )
  }

  renderMessage = () => {
    // testing out path controls UX change
    return null
  }

  renderStats = () => {
    // testing out path controls UX change
    return null
  }

  renderNotes = () => {
    return (
      <Tooltip title={this.props.t("path.controls.notes")}>
        <Button {...Object.assign({}, styles, { to: this.props.toNotes })}>
          <Pathicon icon="note" />
          {this.props.note_count_total ? (
            <span> {this.props.note_count_total}</span>
          ) : undefined}
        </Button>
      </Tooltip>
    )
  }

  renderExpand = () => {
    return (
      <Tooltip title={this.props.t("path.controls.expand")}>
        <Button
          {...Object.assign({}, styles, {
            onClick: this.props.expandAllGroups
          })}
        >
          <Pathicon icon="expand-2" />
        </Button>
      </Tooltip>
    )
  }

  renderCollapse = () => {
    return (
      <Tooltip title={this.props.t("path.controls.collapse")}>
        <Button
          {...Object.assign({}, styles, {
            onClick: this.props.collapseAllGroups
          })}
        >
          <Pathicon icon="collapse-2" />
        </Button>
      </Tooltip>
    )
  }

  renderViewAs = () => {
    return <PathViewAsControl {...Object.assign({}, styles)} />
  }

  render() {
    const { mode, offering, analytics, showNotes, showPerformance } = this.props

    return (
      <ScreensizeContext.Consumer>
        {(screensize) => (
          <div className="PathActionControls">
            {mode === LEARN && showPerformance
              ? this.renderPerformance()
              : undefined}
            {mode === TEACH && offering.seats_filled > 0
              ? this.renderMembers()
              : undefined}
            {mode === TEACH ? this.renderMessage() : undefined}
            {(analytics != null ? analytics.id : undefined) && mode === TEACH
              ? this.renderStats()
              : undefined}
            {mode === TEACH ? this.renderReview() : undefined}
            {mode === DESIGN && screensize !== "sm"
              ? this.renderExpand()
              : undefined}
            {mode === DESIGN && screensize !== "sm"
              ? this.renderCollapse()
              : undefined}
            {showNotes ? this.renderNotes() : undefined}
            {this.renderViewAs()}
          </div>
        )}
      </ScreensizeContext.Consumer>
    )
  }
}

PathActionControls.displayName = "PathActionControls"

const mapStateToProps = function (state, ownProps) {
  const { expandAllGroups, collapseAllGroups } = state.pathStore.action
  const { path_analytics: analytics } = state.pathAnalyticsStore.state
  const { resource, offering } = state.resourceStore.state
  const { path, mode } = state.pathStore.state
  const { notes, note_counter } = state.noteStore.state
  const permissions = state.resourceStore.request.permissions()

  const note_count_total = note_counter || null

  // State
  const feedbackCount = analytics != null ? analytics.need_feedback : undefined
  const showNotes = permissions != null ? permissions.can_access : undefined
  const showPerformance =
    permissions != null ? permissions.can_participate : undefined

  // Routes
  let toReview
  if (path) {
    toReview = {
      pathname: getReviewRoute(),
      query: {
        cohort_id: offering.id,
        ...(feedbackCount > 0 ? { filter: "pending" } : {})
      }
    }
  }
  const toNotes = `${offering.url}path/notes/`
  const toMembers = `${offering.url}path/member/`
  const toMessage = `${offering.url}path/message/`
  const toAnalytics = urls.modalRoute(`${offering.url}path/analytics/`)
  const toPerformance = `${offering.url}performance/`

  return _.assign(
    {},
    {
      // state
      offering,
      analytics,
      note_count_total,
      feedbackCount,
      showNotes,
      showPerformance,
      // actions
      expandAllGroups,
      collapseAllGroups,
      // routes
      toNotes,
      toReview,
      toMembers,
      toMessage,
      toAnalytics,
      toPerformance
    },
    ownProps
  )
}

const stores = [
  { store: "resource", watch: ["offering", "offerings"] },
  { store: "pathAnalytics", watch: ["path_analytics"] },
  { store: "path", watch: ["items", "mode"] },
  { store: "note", watch: ["notes", "note_counter"] }
]

export default withTranslate(
  ConnectStores(PathActionControls, stores, {}, mapStateToProps)
)
